import { InputHTMLAttributes } from "react";
import classes from './Input.module.css'

export const Input = (props: InputHTMLAttributes<HTMLInputElement> ) => {
    return ( 
         <input {...props} className={classes.input}/>
    );
}